import React from 'react';
import { usePriceContext } from 'contracts/utils/priceContext';
import { ContractTextInput } from './ContractFields';
import styled from 'styled-components';

const WarehousingCostWrapper = styled(ContractTextInput)`
  pointer-events: none;
`;
const PriceAdditionalCharges = () => {
  const {
    loadoutSelected,
    freightSelected,
    otherChargesSelected,
    warehousingSelected,
    loadoutCost,
    freightCost,
    otherChargesCost,
    warehousingCost,
  } = usePriceContext();

  return (
    <>
      {loadoutSelected?.value && loadoutCost && (
        <ContractTextInput
          field={loadoutCost?.field}
          value={loadoutCost?.value}
          onChange={loadoutCost?.set}
          type='number'
          step='0.0001'
          min='0.0001'
        />
      )}

      {warehousingSelected?.value && (
        <WarehousingCostWrapper
          field={warehousingCost?.field}
          value={warehousingCost?.value}
          onChange={warehousingCost?.set}
          readonly={false}
          type='number'
          step='0.0001'
          min='0.0001'
        />
      )}

      {freightSelected?.value && (
        <ContractTextInput
          field={freightCost?.field}
          value={freightCost?.value}
          onChange={freightCost?.set}
          type='number'
          step='0.0001'
          min='0.0001'
        />
      )}

      {otherChargesSelected?.value && (
        <ContractTextInput
          field={otherChargesCost?.field}
          value={otherChargesCost?.value}
          onChange={otherChargesCost?.set}
          type='number'
          step='0.0001'
          min='0.0001'
        />
      )}
    </>
  );
};

export default PriceAdditionalCharges;
